<!-- <p>organisation-data-model works!</p> -->
<div class="main-div" *ngIf="!onDashboardManagementPage && !onReportingPage && !onDialog">
    <div *ngIf="organisation" class="title">{{organisation.Name}} Data Model</div>
    <div class="splitter-container alignRow">
        <ejs-splitter #horizontal height='100%' separatorSize=4 width='100%'>
            <e-panes>
                <e-pane size='40%' min='5%'>
                    <ng-template #content>
                        <div class="tree-container">
                            <ejs-treeview #treeview id="treeview" [fields]="fields" (nodeSelected)="selectNode($event)"
                                (nodeDragStop)="onDragIntoTree($event)" [allowDragAndDrop]="true"
                                (nodeExpanded)="nodeExpanded($event)" (nodeCollapsed)="nodeExpanded($event)">
                                <ng-template #nodeTemplate="" let-data="">
                                    <div class="treeviewdiv alignRow">
                                        <mat-icon style="margin-right: 5px;">
                                            {{data.NodeType == "folder" ? "folder"
                                            : data.NodeType == "sensor" ? "sensors"
                                            : data.NodeType == "datapoint" ? "show_chart"
                                            : data.NodeType == "organisation" ? "factory"
                                            : "question_mark"}}
                                        </mat-icon>
                                        <span>{{data.Name}}{{data.Description ? " - " + data.Description : ""}}</span>
                                    </div>
                                </ng-template>
                            </ejs-treeview>
                        </div>
                    </ng-template>
                </e-pane>
                <e-pane size='60%' min='5%'>
                    <ng-template #content>
                        <ng-template [ngTemplateOutlet]="selectedNode ? folderNodeInfo : empty"></ng-template>
                    </ng-template>
                </e-pane>
            </e-panes>
        </ejs-splitter>
    </div>
</div>

<div class="main-div-2 alignRow" *ngIf="onDashboardManagementPage">
    <div class="tree-container">
        <ejs-treeview #treeview id="treeview" [fields]="fields" (nodeSelected)="selectNode($event)"
            [allowDragAndDrop]="true" style="width: 100vw;" (nodeDragStop)="onDragStop($event)">
            <ng-template #nodeTemplate="" let-data="">
                <div class="treeviewdiv alignRow">
                    <mat-icon style="margin-right: 5px;">
                        {{data.NodeType == "folder" ? "folder"
                        : data.NodeType == "sensor" ? "sensors"
                        : data.NodeType == "datapoint" ? "show_chart"
                        : data.NodeType == "organisation" ? "factory"
                        : "question_mark"}}
                    </mat-icon>
                    <span>{{data.Name}}{{data.Description ? " - " + data.Description : ""}}</span>
                </div>
            </ng-template>
        </ejs-treeview>
    </div>
</div>

<div class="main-div-2 alignRow" *ngIf="onReportingPage">
    <div class="tree-container">
        <ejs-treeview #treeview id="treeview" [fields]="fields" (nodeSelected)="selectNode($event)"
            [allowDragAndDrop]="true" style="width: 100%;" (nodeDragStop)="onDragStopReport($event)">
            <ng-template #nodeTemplate="" let-data="">
                <div class="treeviewdiv alignRow">
                    <mat-icon style="margin-right: 5px;">
                        {{data.NodeType == "folder" ? "folder"
                        : data.NodeType == "sensor" ? "sensors"
                        : data.NodeType == "datapoint" ? "show_chart"
                        : data.NodeType == "organisation" ? "factory"
                        : "question_mark"}}
                    </mat-icon>
                    <span>{{data.Name}}{{data.Description ? " - " + data.Description : ""}}</span>
                </div>
            </ng-template>
        </ejs-treeview>
    </div>
</div>

<div class="main-div-3 alignRow" *ngIf="onDialog">
    <div class="tree-container">
        <ejs-treeview #treeviewDialog id="treeviewDialog" [fields]="fields" (nodeSelected)="selectNode($event)"
            [allowDragAndDrop]="true" style="width: 100%;" (nodeDragStop)="onDragStopReport($event)">
            <ng-template #nodeTemplate="" let-data="">
                <div class="treeviewdiv alignRow">
                    <mat-icon style="margin-right: 5px;">
                        {{data.NodeType == "folder" ? "folder"
                        : data.NodeType == "sensor" ? "sensors"
                        : data.NodeType == "datapoint" ? "show_chart"
                        : data.NodeType == "organisation" ? "factory"
                        : "question_mark"}}
                    </mat-icon>
                    <span>{{data.Name}}{{data.Description ? " - " + data.Description : ""}}</span>
                </div>
            </ng-template>
        </ejs-treeview>
    </div>
</div>

<ng-template #folderNodeInfo>
    <div class="node-info-title alignRow">
        <mat-icon style="margin-right: 5px;">
            {{selectedNode?.NodeType == "folder" ? "folder"
            : selectedNode?.NodeType == "sensor" ? "sensors"
            : selectedNode?.NodeType == "datapoint" ? "show_chart"
            : selectedNode?.NodeType == "organisation" ? "factory"
            : "question_mark"}}
        </mat-icon>
        <span>{{getNodeTitle(selectedNode!)}}</span>
        <span class="toolbar-spacer"></span>
        <div class="node-buttons alignRow">
            <button mat-icon-button *ngIf="selectedNode.NodeType == 'folder' || selectedNode.NodeType == 'organisation'"
                class="alignRow" matTooltip="Add Child Node" (click)="openAddChildNodeDialog(selectedNode)">
                <mat-icon>add</mat-icon>
            </button>
            <button mat-icon-button
                *ngIf="selectedNode.NodeType != 'organisation' && selectedNode.NodeType != 'datapoint'"
                [disabled]="selectedNode.NodeType != 'sensor' && (selectedNode.SubChild && selectedNode.SubChild.length > 0)"
                class="alignRow" matTooltip="Delete Node" (click)="deleteOrganisationDataModelNode(selectedNode)">
                <mat-icon style="color: salmon;">delete</mat-icon>
            </button>
        </div>
        <!-- <app-sparkle-line [LineData]="selectedNode.SparkleLineData"
            *ngIf="selectedNode?.NodeType == 'datapoint'"></app-sparkle-line> -->
    </div>
    <hr style="margin-left: 0.5em; margin-right: 0.5em;">
    <div class="node-info">
        <span>Description:</span>
        <span>{{selectedNode?.Description}}</span>
        <span>Level:</span>
        <span>{{selectedNode?.NodeLevel}}</span>
        <span *ngIf="selectedNode?.NodeType == 'folder' || selectedNode?.NodeType == 'sensor'">
            {{selectedNode?.NodeType == 'folder' ? "Children" : selectedNode?.NodeType == 'sensor' ? "DataPoints" :
            ""}}:</span>
        <span *ngIf="selectedNode?.NodeType == 'folder' || selectedNode?.NodeType == 'sensor'">
            {{selectedNode?.SubChild ? selectedNode?.SubChild!.length : 0}}</span>
    </div>
</ng-template>

<ng-template #folderNodeInfo2>
    <div class="node-info-title alignRow">
        <mat-icon style="margin-right: 5px;">
            {{selectedNode?.NodeType == "folder" ? "folder"
            : selectedNode?.NodeType == "sensor" ? "sensors"
            : selectedNode?.NodeType == "datapoint" ? "show_chart"
            : selectedNode?.NodeType == "organisation" ? "factory"
            : "question_mark"}}
        </mat-icon>
        <span>{{getNodeTitle(selectedNode!)}}</span>
    </div>
    <hr style="margin-left: 0.5em; margin-right: 0.5em;">
    <div class="node-info">
        <span>Description:</span>
        <span>{{selectedNode?.Description}}</span>
        <span>Level:</span>
        <span>{{selectedNode?.NodeLevel}}</span>
        <span *ngIf="selectedNode?.NodeType == 'folder' || selectedNode?.NodeType == 'sensor'">
            {{selectedNode?.NodeType == 'folder' ? "Children" : selectedNode?.NodeType == 'sensor' ? "DataPoints" :
            ""}}:</span>
        <span *ngIf="selectedNode?.NodeType == 'folder' || selectedNode?.NodeType == 'sensor'">
            {{selectedNode?.SubChild ? selectedNode?.SubChild!.length : 0}}</span>
    </div>
</ng-template>

<ng-template #empty>

</ng-template>